import { track } from './track';

track('pageView');

addEventListener('clientRoute', () => track('pageView'));
